import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import Reveal from './Reveal';
import { VIDEO } from '@/config/site';

function Corner({ className }) {
  return <span className={`absolute h-4 w-4 border-gold/70 ${className}`} />;
}

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);
  useEffect(() => {
    if (playing && videoRef.current) videoRef.current.play().catch(() => {});
  }, [playing]);
  return (
    <section id="video" data-testid="video-section" className="border-t border-white/5 bg-obsidian px-5 py-24 sm:px-10 sm:py-32">
      <div className="mx-auto max-w-6xl text-center">
        <Reveal>
          <p className="mb-6 flex items-center justify-center gap-3 text-[10px] uppercase tracking-[0.45em] text-gold">
            <span className="h-px w-8 bg-gold/60" /> Main video <span className="h-px w-8 bg-gold/60" />
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-4xl uppercase leading-[1.02] text-cream sm:text-6xl" data-testid="video-headline">
            Mi historia.
            <span className="block italic text-silver">Sin filtros.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="relative mx-auto mt-14 w-full max-w-[320px]" data-testid="video-player">
            <Corner className="left-0 top-0 border-l border-t" />
            <Corner className="right-0 top-0 border-r border-t" />
            <Corner className="bottom-0 left-0 border-b border-l" />
            <Corner className="bottom-0 right-0 border-b border-r" />
            <div className="relative m-2 aspect-[9/16] overflow-hidden border border-white/10 bg-charcoal">
              {playing ? (
                <motion.video
                  ref={videoRef}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  src={VIDEO.src}
                  poster={VIDEO.poster}
                  controls
                  autoPlay
                  playsInline
                  className="h-full w-full object-cover"
                  data-testid="video-playing"
                />
              ) : (
                <button type="button" data-testid="video-play-button" onClick={() => setPlaying(true)} className="group absolute inset-0 h-full w-full">
                  <img src={VIDEO.poster} alt="Mi historia — Cristian Cruz" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                  <span className="absolute inset-0 bg-gradient-to-t from-noir/70 via-transparent to-noir/30" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold/50 bg-noir/40 text-gold backdrop-blur-sm transition-all duration-300 group-hover:scale-110 group-hover:bg-gold group-hover:text-noir">
                      <Play size={20} className="ml-0.5" fill="currentColor" />
                    </span>
                  </span>
                  <span className="absolute bottom-5 left-0 right-0 text-center text-[9px] uppercase tracking-[0.4em] text-cream/60">Reproducir con sonido</span>
                </button>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
